import React, { useEffect, useState } from "react"
import { useTranslation } from "next-i18next"
import { getTranslations } from "@/components/PartsViewer/v2/localization"
import { isImgUrlValid } from "@/services/ImageUrlValid"
import useViewport from "@/hooks/useViewport"
import {
  getPersonaPriceDetails,
  getProductCartQuantity,
} from "@/components/PartsViewer/v2/helper"
import swatchMissing from "@/public/images/swatch-missing.jpeg"
import CONSTANTS from "@/constants/index"
import ListCardLoading from "@/components/PartsViewer/v2/GridAndListPanel/ListView/LoadingCard"
import commingSoon from "@/public/scout_icon/coming-soon.jpg"
import { selectCartState } from "@/store/features/cartSlice"
import { useSelector } from "react-redux"
import CartButton from "@/components/PartsViewer/v2/CartButton/Index"
import { sortedVal } from "@/components/PartsViewer/v2/GridAndListPanel/utils"
import PropTypes from "prop-types"
import { isCanadaSite } from "@/utils/helper"

const ListView = props => {
  const {
    dataPromise,
    showPopup,
    isListExtend,
    dataInput,
    showCart,
    setShowCart,
    showCartPopUp,
    siteName,
  } = props

  const [validUrl, setValidUrl] = useState({ status: "loading" })
  const [loading, setLoading] = useState("notStarted")
  const [productSwatche, setProductSwatche] = useState({})
  const device = useViewport()
  const [colour, setColour] = useState()
  const [selectedVariant, setSelectedVariant] = useState(null)
  const [colorItem, setColorItem] = useState(null)
  const [swatches, setSwatches] = useState(null)
  const [showProduct, setShowProduct] = useState(true)
  const { t } = useTranslation("common")
  const { outOfStockText, discontinuedText, replacesText } = getTranslations(t)

  const {
    Name: name,
    productName,
    productId,
    imageUrl: image,
    priceInfo,
    productInventoryInfo,
    isAddedFlag,
    cartQuantity,
  } = productSwatche
  const personaPriceList = getPersonaPriceDetails(dataInput)
  const kohlerCanadaFlag = isCanadaSite(siteName)
  const { cart } = useSelector(selectCartState)
  useEffect(() => {
    getListData()
  }, [cart])

  useEffect(() => {
    updateImgUrl()
  }, [productSwatche?.imageUrl])

  const updateImgUrl = async () => {
    if (productSwatche?.imageUrl) {
      const res = await isImgUrlValid(productSwatche?.imageUrl)
      if (res) {
        setValidUrl({ status: "success" })
      } else {
        setValidUrl({ status: "failed" })
      }
    } else {
      setValidUrl({ status: "failed" })
    }
  }

  const getListData = async () => {
    setLoading("loading")
    const res = await dataPromise
    if (res?.data) {
      const { Name, productId, productIdKey, data: list, activeItem } = res
      const productName = res?.data?.productName_s || Name
      const imageUrl = list?.colorData[0]?.imgUrl
      const priceInfo = list?.colorData?.filter(
        item => item.id === activeItem
      )?.[0]
      const productInventoryInfo = list?.varientDetails?.filter(
        item => item.sku === activeItem
      )?.[0]
      const isAddedOne = getProductCartQuantity(
        list["Color.SKU.Details_ss"],
        cart,
        productId,
        activeItem
      )
      const cartQuantity = isAddedOne ? isAddedOne.totalQunatity : ""
      const isAddedFlag = isAddedOne?.isAddedFlag
      setProductSwatche({
        Name,
        productName,
        productId,
        imageUrl,
        productIdKey,
        priceInfo,
        productInventoryInfo,
        isAddedFlag,
        cartQuantity,
      })
      if (res?.data) {
        const getSwatches = list?.varientDetails
        const filterSwatch = getSwatches.filter(
          val => val["swatch"] !== "swatch_NA"
        )
        const colorArray = personaPriceList.map(item => {
          const matchItem = Object.values(filterSwatch).find(
            element => item.sku === element.sku
          )
          if (matchItem) return { ...item, ...matchItem }
          else return item
        })
        const sortArrayVal = sortedVal(colorArray)
        setColour(sortArrayVal)
        const activeItems = sortArrayVal?.filter(v =>
          v?.swatch ? v?.swatch !== "swatch_NA" : v[0]
        )
        const firstItems = activeItems[0]
        setColorItem(firstItems)
        setSelectedVariant(firstItems)
        setSwatches(getSwatches)
      }
      setLoading("loaded")
    } else {
      setLoading("loaded")
      setShowProduct(false)
    }
  }

  if (showProduct && loading !== "loaded") return <ListCardLoading />

  const colorCount = 5
  let extraColor
  if (colour?.length > colorCount) {
    extraColor = colour?.length - colorCount
  }
  let marginStyle
  let flexDirection
  const forMediumScreen = device?.isMediumScreen && !isListExtend

  if (forMediumScreen) {
    marginStyle = "mx-0 marginStyle"
    flexDirection = "flex-column"
  } else if (colour?.length > 1) {
    if (device?.isSmallScreen) {
      marginStyle = "marginStyle"
    } else {
      marginStyle = "ml-10 tag-discontinue-position"
    }
  }
  const colorSwatchDefaultImg = e => {
    e.target.src = swatchMissing.src
  }
  const forAllSmallScreen =
    device.isMediumScreen || device?.isSmallScreen || device?.isExtraSmallScreen
  const listviewCls =
    !isListExtend && device.isMediumScreen ? "mx-0 p-0 mt-5" : "sku-cart-margin"
  const skuPriceClass =
    isListExtend && !device.isMediumScreen ? "justify-content-end" : listviewCls
  let cadPriceWidth = ""
  if (isListExtend) {
    cadPriceWidth = kohlerCanadaFlag ? "width-50" : "w-25"
  }
  let titleAlignCenter = ""
  if (isListExtend && (device.isExtraLargeScreen || device.isLargeScreen)) {
    if (
      !productInventoryInfo?.discontinued &&
      !(
        productInventoryInfo?.isStock === "false" &&
        productInventoryInfo?.discontinued === false
      )
    ) {
      titleAlignCenter = true
    }
  }

  const varientPrices = selectedVariant ? selectedVariant : priceInfo
  let showAddTocart = false
  if (
    (!isListExtend && device.isExtraLargeScreen) ||
    device?.isLargeTabView ||
    (device?.isMediumScreen && isListExtend)
  ) {
    showAddTocart = true
  }

  const chkDiscontinue = selectedVariant
    ? selectedVariant?.discontinued
    : productInventoryInfo?.discontinued

  const outOfStock = selectedVariant
    ? !selectedVariant?.discontinued && selectedVariant?.isStock === "false"
    : productInventoryInfo?.isStock === "false" &&
      productInventoryInfo?.discontinued === false

  const handlerButton = arg => {
    if (arg) {
      setShowCart(!showCart)
      showCartPopUp(productId)
    }
  }
  const replaceSku = dataInput?.partApi?.replaceRootSku
  if (!showProduct) return null
  return (
    <div className={`card border-active list-section`}>
      <div
        className={`card-bodys d-flex justify-content-between`}
        onClick={() => {
          showPopup(productId)
        }}
        data-testid="list-card"
        onKeyDown={() => {
          showPopup(productId)
        }}
      >
        <div className="d-flex w-100 flex-grow-1">
          <div className="thumb-list">
            {validUrl?.status === "loading" ? (
              <div className="loading-spinner">
                <div className="shimmer-loading__image shimmer"></div>
              </div>
            ) : (
              <img
                width="60px"
                height="60px"
                className="card-img"
                src={validUrl.status === "success" ? image : commingSoon?.src}
                alt={name}
              />
            )}
          </div>
          <div className="d-flex w-100 flex-grow-1">
            <div
              className={`d-flex justify-content-between w-100 flex-grow-1 
                ${forAllSmallScreen ? "flex-column" : ""}
                ${
                  isListExtend && !device?.isMediumScreen
                    ? "flex-row ms-4"
                    : "flex-column"
                } pt-2 pb-2`}
            >
              <div className="d-flex flex-column">
                <div
                  className={`color-variants list-color ${
                    forMediumScreen ? "d-block" : "color-parts"
                  }`}
                >
                  {colour?.length > 1 ? (
                    colour?.slice(0, colorCount)?.map(item =>
                      item?.swatch !== undefined ? (
                        <label
                          key={item["swatch"]}
                          className="other_color"
                          onMouseEnter={() => setSelectedVariant(item)}
                          onMouseLeave={() => setSelectedVariant(colorItem)}
                        >
                          <img
                            width="20px"
                            height="20px"
                            className="img_variant_color"
                            src={CONSTANTS.COLOR_FILE_URL + item["swatch"]}
                            alt={item["name"]}
                            onError={e => colorSwatchDefaultImg(e)}
                            title={
                              selectedVariant
                                ? selectedVariant[0]
                                : item["name"]
                            }
                          />
                        </label>
                      ) : (
                        ""
                      )
                    )
                  ) : (
                    <>
                      {titleAlignCenter ? (
                        <div className="title-center-align"></div>
                      ) : (
                        ""
                      )}
                    </>
                  )}

                  {extraColor ? (
                    <label className="extra-color">+{extraColor}</label>
                  ) : (
                    ""
                  )}

                  {chkDiscontinue ? (
                    <label
                      className={`fs-13 fw-600 tag-discontinue discontinued label-discontinued ${marginStyle}`}
                    >
                      {discontinuedText}
                    </label>
                  ) : (
                    ""
                  )}

                  {outOfStock && !kohlerCanadaFlag ? (
                    <label
                      className={`fs-13 fw-600 tag-discontinue outof-stoke label-discontinued ${marginStyle} `}
                    >
                      {outOfStockText}
                    </label>
                  ) : null}
                </div>

                <div className="d-flex align-items-center justify-content-between mb-5">
                  <p
                    fontSize={18}
                    className={`card-text fw-400 tablet-view-padding ${
                      isListExtend
                        ? "model-name-list "
                        : "model-name list-items"
                    } text-capitalize`}
                  >
                    {productName ?? name?.toLowerCase()}
                  </p>
                </div>
              </div>
              <div
                className={`d-flex card-text fw-400 align-items-center list-details list-fullwidth-tab position-relative ${
                  isListExtend ? "list-fullwidth" : ""
                } ${!showAddTocart ? "justify-content-between" : ""} `}
              >
                <div
                  className={`model-name d-flex ${flexDirection} ${
                    isListExtend && !device.isMediumScreen
                      ? "justify-content-end w-75"
                      : ""
                  }`}
                >
                  <p fontSize={14} className="sku-name">
                    {varientPrices
                      ? varientPrices?.customerSku || dataInput?.partApi?.skuId
                      : varientPrices?.value || dataInput?.partApi?.skuId}
                    {replaceSku ? (
                      <span className="replaceVal">
                        ({replacesText} {replaceSku})
                      </span>
                    ) : null}
                  </p>

                  <p
                    fontSize={14}
                    className={`model-prices d-flex  
                      ${skuPriceClass} ${cadPriceWidth}`}
                  >
                    <span
                      className={`sku_product ${
                        varientPrices?.discountedPrice
                          ? "mx-1 discount-price"
                          : ""
                      }`}
                    >
                      {varientPrices?.currencySign + varientPrices?.price ||
                        null}
                    </span>
                    <span className="model-name-price px-1">
                      {varientPrices?.discountedPrice
                        ? varientPrices?.currencySign +
                          varientPrices?.discountedPrice
                        : null}
                    </span>
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {!kohlerCanadaFlag ? (
        <CartButton
          isAddedFlag={isAddedFlag}
          cartQuantity={cartQuantity}
          handlerButton={handlerButton}
          swatches={swatches}
          list={true}
        />
      ) : null}
    </div>
  )
}

ListView.propTypes = {
  showPopup: PropTypes.bool.isRequired,
  dataPromise: PropTypes.func.isRequired,
  isListExtend: PropTypes.bool.isRequired,
  dataInput: PropTypes.object.isRequired,
  showCart: PropTypes.bool.isRequired,
  setShowCart: PropTypes.func.isRequired,
  showCartPopUp: PropTypes.func.isRequired,
  siteName: PropTypes.string.isRequired,
}

export default ListView
